import styled from 'styled-components';

export const CSSColorPicker = styled.button<{ disabled?: boolean }>`
    background-color: ${(props) => (props.disabled ? props.theme.color.grey2 : 'inherit')};
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: ${(props) => (props.disabled ? 'inherit' : 'pointer')};
    padding: 8px 9px;
    border: 1px solid ${(props) => props.theme.color.grey2};
    border-radius: 8px;

    &:focus {
        border-color: ${(props) => props.theme.color.navy};
        box-shadow: 0 0 2px ${(props) => props.theme.color.grey4};
    }
    ${(props) =>
        !props.disabled &&
        `
            &:hover {
                box-shadow: 0 0 2px ${props.theme.color.grey2};
            }
        `}
`;

export const CSSColorPickerIcon = styled.div`
    align-items: center;
    justify-content: center;
    display: flex;
`;

export const CSSColorPickerLabel = styled.div`
    display: flex;
    flex: 1;
`;

export const CSSColorPickerExpand = styled.div`
    align-items: center;
    justify-content: center;
    display: flex;
`;

const linearGradien = `
    background: linear-gradient(
        to right,
        #ff0000 0%,
        #ffff00 17%,
        #00ff00 33%,
        #00ffff 50%,
        #0000ff 67%,
        #ff00ff 83%,
        #ff0000 100%
    );`;
const boxShadow = `box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.025), 0 1px 5px rgba(0, 0, 0, 0.25);`;

export const CSSInput = styled.div<{ hue: string; width: number }>`
    input {
        width: ${(props) => props.width}px;
        margin: 12px 0;
        padding: 0;
        min-height: 24px;
        background: transparent;
        outline: none;

        &,
        &::-webkit-slider-thumb {
            -webkit-appearance: none;
        }

        &::-webkit-slider-runnable-track {
            border: none;
            width: 100%;
            height: 8px;
            border-radius: 4px;
            ${linearGradien}
        }
        &::-moz-range-track {
            border: none;
            width: 100%;
            height: 8px;
            border-radius: 4px;
            ${linearGradien}
        }
        &::-ms-track {
            border: none;
            width: 100%;
            height: 8px;
            border-radius: 4px;
            ${linearGradien}
        }
        &::-webkit-slider-thumb {
            margin-top: -8px;
            border: 4px solid white;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            cursor: grab;
            background: hsl(${(props) => props.hue}, 100%, 50%);
            ${boxShadow}
        }
        &::-moz-range-thumb {
            border: 4px solid white;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            cursor: grab;
            background: hsl(${(props) => props.hue}, 100%, 50%);
            ${boxShadow}
        }
        &::-ms-thumb {
            margin-top: 0;
            border: 4px solid white;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            cursor: grab;
            background: hsl(${(props) => props.hue}, 100%, 50%);
            ${boxShadow}
        }

        &::-ms-tooltip {
            display: none;
        }
        &:focus,
        &:active {
            + .c-range__output {
                opacity: 1;
            }
        }
    }
`;
